import SliderBase from './base-slider';

class StInstagramHandler extends SliderBase {

}

export default ( $scope ) => {
  elementorFrontend.elementsHandler.addHandler( StInstagramHandler, { $element: $scope } );
};